import { Pipe, PipeTransform } from '@angular/core';
import { messageAuthorLabel, RawTicketMessageAuthor } from '../_utils/ticket-message-author';

// {{ message | ticketMessageAuthor }} / {{ message | ticketMessageAuthor: 'portal' }}
// for raw (snake_case) ticket messages - see messageAuthorLabel.
@Pipe({
  name: 'ticketMessageAuthor'
})
export class TicketMessageAuthorPipe implements PipeTransform {
  transform(
    message: RawTicketMessageAuthor | null | undefined,
    view: 'staff' | 'portal' = 'staff'
  ): string {
    return messageAuthorLabel(message, view);
  }
}
